export function verificaSeEParaInserirOuAtualizarContato(idLead, emailSalvoPrimeiraPage, emailForm){
  return !idLead || (emailSalvoPrimeiraPage && emailSalvoPrimeiraPage !== emailForm)
}